import { BasicCommand } from "../../common/services/cqs/BasicCommand";
import { CommandType } from "../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../common/services/cqs/IPrimaryKey";

export class UpdateClientFeatureCommand extends BasicCommand<UpdateClientFeatureCommand> {
    get primaryKey(): IPrimaryKey<UpdateClientFeatureCommand> {
        return {
            userId: this.userId
        };
    }
    userId: number;
    featureIds: number[];

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Features";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateClientFeatureCommand";
    constructor(init: (instance: UpdateClientFeatureCommand) => void) {
        super(UpdateClientFeatureCommand.$type, UpdateClientFeatureCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
